module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-2.4be2f8d0.png";